/* eslint-disable react-hooks/exhaustive-deps */
import { BrowserRouter as Router } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import Main from "./routes/main/Main";
import City from "./routes/city/City";
import Loader from "./components/layout/Loader";
import useAxios from "./shared/hooks/use-axios";
import { url } from "./shared/utils/url";
import { getApp } from "./shared/utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { dataActions } from "./shared/store/data-Slice";
import { Helmet } from 'react-helmet';
import app from '../package.json';
import CacheBuster from 'react-cache-buster';
import { authActions } from "./shared/store/auth-Slice";
import SeoHelmet from "./components/layout/SeoHelmet";

const OrganizationSchema = () => {
    const schema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Uttar Pradesh Metro Rail Corporation Limited",
        "url": "https://upmetrorail.com"
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
};

const MainRouter = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const user: any = useSelector((state: any) => state.auth.user);
    const lang: string = useSelector((state: any) => state.ui.lang);
    let [loader, setLoader] = useState<any>(true);
    const [tenantData, setTanantData] = useState<any[]>([]);
    const Components: any = !loader && getApp(tenantData);
    const dispatch = useDispatch();

    useEffect(() => {
        if (theme === "dark") {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }

        !!theme && localStorage.setItem("theme", theme);
    }, [theme]);

    const getCityData = async () => {
        try {

            const res: any = await useAxios.get(`/en${url?.city}`);

            if (res && res?.status === 200) {
                // for tenant setting
                let tenant: any = "";
                let arr: any[] = [];
                let cityObj: any = {};
                let helpLineObj: any = {};
                for (let i = 0; i < res?.data?.length; i++) {
                    const el = res?.data[i];
                    let domainCode: string = (url?.env === "live" ? el?.code : url?.env === "prod" ? `${el?.code}-upmrc-prod` : `${el?.code}-upmrc-uat`)
                    if (window.location.hostname?.includes(domainCode)) {
                        tenant = window.location.hostname?.replace(`${domainCode}.`, "")
                    }

                    let obj: any;
                    if (!!tenant) {
                        obj = {
                            subdomain: domainCode + "." + tenant,
                            app: City,
                            main: false
                        }
                    } else {
                        obj = {
                            subdomain: domainCode + "." + window.location.hostname,
                            app: City,
                            main: false
                        }
                    }

                    helpLineObj[el.name.toLowerCase()] = el?.emergency_nums

                    if (!cityObj?.hasOwnProperty(el?.code)) {
                        cityObj[el.name.toLowerCase()] = el?.id
                    }
                    arr.push(obj)
                }

                if (url?.env === "live") {
                    arr.push({
                        subdomain: !!tenant ? tenant : window.location.hostname,
                        app: Main,
                        main: true
                    })
                } else if (url?.env === "prod") {
                    arr.push({
                        subdomain: "upmrc-prod." + window.location.hostname?.toString()?.replace("upmrc-prod.", ""),
                        app: Main,
                        main: true
                    })
                } else {
                    arr.push({
                        subdomain: "upmrc-uat." + window.location.hostname?.toString()?.replace("upmrc-uat.", ""),
                        app: Main,
                        main: true
                    })
                }

                setTanantData(arr);
                setLoader(false);

                // for city name wise id get
                dispatch(dataActions.setCities(cityObj));
                dispatch(dataActions.setHelpLine(helpLineObj));

            }
        } catch (error) {

            console.error("error while feching city data", error);
        }
    };

    useEffect(() => {
        getCityData()
    }, [])

    useEffect(() => {
        const getTokenDetails = async () => {
            try {
                const res: any = await useAxios.post(`/${lang + url?.getTokenDetail}`, { "refresh_token": user?.refresh });

                if (res && res?.status === 200 && !res?.data?.status) {
                    dispatch(authActions.logout());
                    dispatch(authActions.userDetail(null));
                }
            } catch (error) {
                console.error("error while feching token details", error);
            }
        }

        (!!user && !!lang) && getTokenDetails();
    }, [user, lang])

    return (
        <>
            <CacheBuster
                currentVersion={app.version}
                isEnabled={true}
                reloadOnDowngrade={true}
                isVerboseMode={true}
                loadingComponent={<Loader />}
                metaFileDirectory={'.'}
                onCacheClear={(refreshCacheAndReload: () => Promise<void>) => { }}
            >
                <>
                    <OrganizationSchema />
                    <SeoHelmet />
                    <Suspense fallback={<Loader />}>
                        {!loader &&
                            <Router>
                                <Components />
                            </Router>
                        }
                    </Suspense>
                </>
            </CacheBuster>
        </>
    );
};

export default MainRouter;